export default __webpack_public_path__ + "static/sparkle-b2f646cdac126be6615aafdf0fa7b21b.svg";